import { render, staticRenderFns } from "./borrowDetailPrint.vue?vue&type=template&id=7471d58e&scoped=true&"
import script from "./borrowDetailPrint.vue?vue&type=script&lang=js&"
export * from "./borrowDetailPrint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7471d58e",
  null
  
)

export default component.exports